import { useContext } from 'react';
import { BrandInfoContext } from '@core-ui/brand-info-provider';
import useEnabledFeature from '../../useEnabledFeature';
import useEnabledSegment from '../../useEnabledSegment';
const useColorSwatches = (): boolean => {
  const { abbrBrand } = useContext(BrandInfoContext);
  const colorSwatchesFeatureEnabled = useEnabledFeature('cat-color-swatches');

  const colorSwatchesExperimentEnabled = useEnabledSegment(`${abbrBrand}117`);

  return colorSwatchesFeatureEnabled && colorSwatchesExperimentEnabled;
};

export default useColorSwatches;
